import React from 'react';
import Building from "../../../components/pages/form/Building/Building";

const BuildingPage = () => {
    return <Building />
};

export default BuildingPage;
